import { type NotificationStore } from "./notification-store";
import { TONE_CLASSES } from "./tokens";

// ヘッダのベル(SVG, 絵文字回避) + 未読バッジ + ドロップダウン通知一覧。store を subscribe。
export function createNotificationBell(store: NotificationStore): HTMLElement {
  const wrap = document.createElement("div");
  wrap.className = "relative";

  const btn = document.createElement("button");
  btn.type = "button";
  btn.className = "relative inline-flex items-center rounded border border-slate-300 p-1.5 text-slate-700 hover:bg-slate-100";

  const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  svg.setAttribute("viewBox", "0 0 24 24");
  svg.setAttribute("width", "18");
  svg.setAttribute("height", "18");
  svg.setAttribute("fill", "none");
  svg.setAttribute("stroke", "currentColor");
  svg.setAttribute("stroke-width", "2");
  svg.setAttribute("aria-hidden", "true");
  const p1 = document.createElementNS("http://www.w3.org/2000/svg", "path");
  p1.setAttribute("d", "M18 8a6 6 0 1 0-12 0c0 7-3 9-3 9h18s-3-2-3-9");
  const p2 = document.createElementNS("http://www.w3.org/2000/svg", "path");
  p2.setAttribute("d", "M13.7 21a2 2 0 0 1-3.4 0");
  svg.append(p1, p2);
  btn.append(svg);

  const badge = document.createElement("span");
  badge.dataset["testid"] = "bell-badge";
  badge.className = "absolute -right-1 -top-1 inline-flex min-w-[1rem] items-center justify-center rounded-full bg-red-600 px-1 text-[10px] font-medium text-white";
  btn.append(badge);

  const panel = document.createElement("div");
  panel.className = "absolute right-0 z-50 mt-2 hidden w-80 max-w-[90vw] rounded-lg border border-slate-200 bg-white shadow-lg";

  const panelHeader = document.createElement("div");
  panelHeader.className = "flex items-center justify-between border-b border-slate-200 px-3 py-2";
  const ph = document.createElement("span");
  ph.className = "text-sm font-medium text-slate-900";
  ph.textContent = "通知";
  const markAll = document.createElement("button");
  markAll.type = "button";
  markAll.className = "text-xs text-shinonome-700 hover:underline";
  markAll.textContent = "すべて既読";
  markAll.addEventListener("click", () => store.markAllRead());
  panelHeader.append(ph, markAll);

  const listEl = document.createElement("ul");
  listEl.className = "max-h-80 overflow-y-auto";

  panel.append(panelHeader, listEl);
  wrap.append(btn, panel);

  let open = false;
  btn.addEventListener("click", () => {
    open = !open;
    panel.classList.toggle("hidden", !open);
  });

  function render(): void {
    const unread = store.unreadCount();
    btn.setAttribute("aria-label", "通知 (未読 " + unread + " 件)");
    if (unread > 0) {
      badge.textContent = String(unread);
      badge.classList.remove("hidden");
    } else {
      badge.textContent = "";
      badge.classList.add("hidden");
    }
    listEl.replaceChildren();
    const items = store.list();
    if (items.length === 0) {
      const li = document.createElement("li");
      li.className = "px-3 py-4 text-sm text-slate-500";
      li.textContent = "通知はありません。";
      listEl.append(li);
      return;
    }
    for (const n of items) {
      const li = document.createElement("li");
      li.dataset["testid"] = "notification-item";
      li.className = "flex gap-2 border-b border-slate-100 px-3 py-2 " + (n.read ? "" : "bg-shinonome-50");
      const dot = document.createElement("span");
      dot.className = "mt-1 h-2 w-2 shrink-0 rounded-full " + TONE_CLASSES[n.tone].dot;
      const txt = document.createElement("div");
      const title = document.createElement("p");
      title.className = "text-sm text-slate-900";
      title.textContent = n.title;
      txt.append(title);
      if (n.message !== undefined && n.message !== "") {
        const msg = document.createElement("p");
        msg.className = "text-xs text-slate-600";
        msg.textContent = n.message;
        txt.append(msg);
      }
      if (n.ts !== "") {
        const ts = document.createElement("p");
        ts.className = "text-[10px] text-slate-400";
        ts.textContent = n.ts;
        txt.append(ts);
      }
      li.append(dot, txt);
      li.addEventListener("click", () => store.markRead(n.id));
      listEl.append(li);
    }
  }

  render();
  store.subscribe(render);
  return wrap;
}
